'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useDemoUI } from '@/context/providers/UIProvider';
import useGetLangPath from '@/helpers/getLangPath';

export const usePageLoading = () => {
	const { pageLoading, startPageLoading, stopPageLoading, resetPageLoading } = useDemoUI();

	return {
		isPageLoading: pageLoading,
		startPageLoading,
		stopPageLoading,
		resetPageLoading,
	};
};

export const useNavigateWithPageLoading = () => {
	const router = useRouter();
	const getLangPath = useGetLangPath();
	const { startPageLoading } = usePageLoading();

	const navigate = useCallback(
		(routeKey, { replace = false } = {}) => {
			if (!routeKey) return;

			startPageLoading();
			const path = getLangPath(routeKey);

			if (replace) router.replace(path);
			else router.push(path);
		},
		[getLangPath, router, startPageLoading]
	);

	return navigate;
};
